// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import rdata from './data.json'
import React from 'react'
import Logic from './logic'

/** @type {import('Simple/types.js').Data} */
export default function ContentData(props) {
  let data = rdata.value

  return (
    <DataProvider
      context="filters"
      value={data}
      viewPath={props.viewPath}
    >
      <Logic {...props} />
    </DataProvider>
  )
}